import React, { useEffect, useState } from 'react'
import moment from 'moment'
import { InputField } from '@enamelai/design-system'

const DISPLAY_FORMAT = 'MM/DD/YYYY'
const VALUE_FORMAT = 'YYYY-MM-DD'

const toDisplay = (value: string): string => {
  const parsed = moment(value, VALUE_FORMAT, true)
  return parsed.isValid() ? parsed.format(DISPLAY_FORMAT) : ''
}

type ModalDateFieldProps = {
  label: string
  /** YYYY-MM-DD, or '' when empty. */
  value: string
  onChange: (value: string) => void
  error?: string
}

function ModalDateField({
  label,
  value,
  onChange,
  error,
}: ModalDateFieldProps): React.ReactElement {
  const [text, setText] = useState(() => toDisplay(value))

  useEffect(() => {
    setText(toDisplay(value))
  }, [value])

  return (
    <InputField
      fullWidth
      variant="date"
      label={label}
      placeholder={DISPLAY_FORMAT}
      value={text}
      error={!!error}
      helperText={error || undefined}
      onChange={(e) => {
        const next = e.target.value
        setText(next)
        const parsed = moment(next, DISPLAY_FORMAT, true)
        if (parsed.isValid()) onChange(parsed.format(VALUE_FORMAT))
        else if (!next.trim()) onChange('')
      }}
      onDateChange={(date) => onChange(moment(date).format(VALUE_FORMAT))}
    />
  )
}

export default ModalDateField
